import { render } from "./RelationField.vue?vue&type=template&id=f5569484"
import script from "./RelationField.vue?vue&type=script&lang=js"
export * from "./RelationField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__